import React from 'react';
import { Component } from "puzzle";
import * as _ from "lodash";

type PROPS = {
  data: any[],
  claimSwitch: 'Claim' | 'Unclaim' //whether it is claim or unclaim action
}

type STATE = {
  tasks: any[]
}

class MultiClaimFailedTasksWarning extends Component<PROPS, STATE> {

  moduleDidMount = () => {
    const { data } = this.props;
    const groupedData: { [reason: string]: any[] } = {};

    data.forEach((item: any) => {
      if (groupedData[item.reason]) {
        groupedData[item.reason].push(item);
      } else {
        groupedData[item.reason] = [item];
      }
    });
    this.setState({ tasks: groupedData });
  }

  /**
   * Content of all related failed tasks
   */
  renderContent = () => {
    const { tasks } = this.state;
    return (
      <>
        {Object.keys(tasks).map((reason: string) => (
          <div key={reason} className={'tp-warning-dialog-list'}>
            <span className={'tp-text-semibold'}>{this.translate(reason)}</span>
            <ul>
              {tasks[reason].map((item: any, index: number) => (
                <li key={reason + index}>
                  {this.translate('item', {
                    id: item.submissionId,
                    batchName: item.batchName,
                    language: item.localizedDisplayName,
                    phaseName: item.phaseName
                  })}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </>
    );
  };

  renderBody() {
    const { claimSwitch } = this.props;
    const { tasks = {} } = this.state;
    return (
      <>
        <span className={"tp-warning-text tp-text-semibold tp-font-size-md"}>
          {this.translate('header' + claimSwitch)}
        </span>
        {!_.isEmpty(tasks) &&
          this.renderContent()
        }
      </>
    );
  }
}

export default MultiClaimFailedTasksWarning;
